<a href="/">
<img id="gainwellLogo" [ngClass]="isDashboard ? 'fcLoginLogoDashboard' : 'fcLoginLogo'" alt="Gainwell Technologies"
 src="../../assets/images/logo.png"></a>
<h1 [ngClass]="isDashboard ? 'fcLoginHeaderDashboard' : 'fcLoginHeader'">
    <a href="/"><span class="fcLoginFraud">File</span>
    <span style="color: white">Capture</span></a>
</h1>
<!-- <LLM_CODE_BEGIN story="US_826609"> -->
<div *ngIf="isInstructionsEnabled" style="margin-bottom: 15px;" [ngClass]="isDashboard ? 'fcInstructionsActionDashboard' : 'fcInstructionsAction'">
    <button class="fcInstructionsBtn" type="button" (click)="showInstructions()" title="View FileCapture Instructions">Instructions</button>
</div>
<!-- <LLM_CODE_END story="US_826609"> -->